const FRAME_INITIALIZE_REQUESTED = 'FRAME_INITIALIZE_REQUESTED'
const LOOKUP_FIELD = 'LOOKUP_FIELD'
const LOOKUP_FIELD_FAILED = 'LOOKUP_FIELD_FAILED'
const LOOKUP_FIELD_SUCCESS = 'LOOKUP_FIELD_SUCCESS'

export default {
  FRAME_INITIALIZE_REQUESTED,
  LOOKUP_FIELD,
  LOOKUP_FIELD_FAILED,
  LOOKUP_FIELD_SUCCESS,
}
